import classNames from "classnames";
import "./style.scss";

type Props = {
  color: "red" | "grey" | "green";
};
export const AnimatedDot = ({ color }: Props) => {
  return (
    <div
      className={classNames("animated-dot", color, {
        blinking: color === "green",
      })}
    ></div>
  );
};
